<script setup lang="ts">
interface Props {
  isLoading?: boolean | null
  message?: string
  global?: boolean
  layout?: 'horizontal' | 'vertical'
}

withDefaults(defineProps<Props>(), {
  isLoading: undefined,
  global: true,
  message: 'Cargando...',
  layout: 'vertical',
})
</script>

<template>
  <div class="relative">
    <Transition
      enter-active-class="transition-opacity duration-500"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-500"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isLoading"
        class="flex flex-col items-center justify-center z-10"
        :class="{
          'fixed top-0 left-0 right-0 bottom-0 z-[1000] h-screen w-screen bg-primary-950': global,
          'w-full absolute': !global,
          'p-8': layout === 'vertical',
          'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2': layout === 'horizontal' && !global,
        }"
      >
        <div
          class="flex justify-center items-center"
          :class="{
            'flex-col': layout === 'vertical',
            'flex-row': layout === 'horizontal',
          }"
        >
          <div
            class="relative"
            :class="{
              'size-32': layout === 'vertical',
              'size-16': layout === 'horizontal',
            }"
          >
            <div
              class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full overflow-hidden bg-white"
              :class="{
                'size-18': layout === 'vertical',
                'size-10': layout === 'horizontal',
              }"
            >
              <ImageComponent
                src="/img/logo.png"
                class="z-10"
                :class="{
                  'size-18': layout === 'vertical',
                  'size-10': layout === 'horizontal',
                }"
              />
            </div>

            <PvProgressSpinner
              class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0"
              :class="{
                'size-24': layout === 'vertical',
                'size-14': layout === 'horizontal',
              }"
            />
          </div>
          <span
            v-if="message"
            class="text-sm md:text-base"
            :class="{
              'text-nowrap': layout === 'vertical',
            }"
          >
            {{ message }}
          </span>
        </div>
      </div>
      <template v-else>
        <slot />
      </template>
    </Transition>
  </div>
</template>
